/** Сервіс повідомлень (UX-13): тости, банери, живий регіон. Опис правил — store.ts. */
export { Banner, BannerSlot } from './Banner.tsx';
export { NotifyHost } from './NotifyHost.tsx';
export {
  announce,
  dismissToast,
  GLOBAL_BANNER,
  hideBanner,
  rememberToastReturn,
  showBanner,
  TOAST_MS,
  type ToastInput,
  takeToastReturn,
  toast,
} from './store.ts';

import { toast } from './store.ts';

/** Тост з компонента: той самий `toast()`; хук лишився для наявних викликів. */
export const useToast = () => toast;
